import Marionette from 'backbone.marionette';
import errorViewTmpl from '../templates/error_view.tpl';
export default Marionette.ItemView.extend({
  template: errorViewTmpl
});